import React from "react";

const StarRating = ({ rating, onRatingChange, readonly = false, size = 20 }) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  const handleStarClick = (starIndex) => {
    if (!readonly && onRatingChange) {
      onRatingChange(starIndex + 1);
    }
  };

  return (
    <div className="flex items-center justify-center gap-1">
      {/* Full stars */}
      {Array.from({ length: fullStars }, (_, index) => (
        <svg
          key={`full-${index}`}
          className={`text-yellow-400 ${readonly ? "" : "cursor-pointer hover:scale-125 transition-all duration-200 hover:drop-shadow-lg"}`}
          width={size}
          height={size}
          fill="currentColor"
          viewBox="0 0 24 24"
          onClick={() => handleStarClick(index)}
        >
          <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
        </svg>
      ))}
      
      {/* Half star */}
      {hasHalfStar && (
        <svg
          className={`text-yellow-400 ${readonly ? "" : "cursor-pointer hover:scale-125 transition-all duration-200 hover:drop-shadow-lg"}`}
          width={size}
          height={size}
          fill="currentColor"
          viewBox="0 0 24 24"
          onClick={() => handleStarClick(fullStars)}
        >
          <defs>
            <linearGradient id="half-star" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="50%" stopColor="currentColor" />
              <stop offset="50%" stopColor="#e5e7eb" />
            </linearGradient>
          </defs>
          <path 
            d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
            fill="url(#half-star)"
          />
        </svg>
      )}
      
      {/* Empty stars */}
      {Array.from({ length: emptyStars }, (_, index) => (
        <svg
          key={`empty-${index}`}
          className={`text-gray-300 ${readonly ? "" : "cursor-pointer hover:scale-125 transition-all duration-200 hover:text-yellow-400 hover:drop-shadow-lg"}`}
          width={size}
          height={size}
          fill="currentColor"
          viewBox="0 0 24 24"
          onClick={() => handleStarClick(fullStars + (hasHalfStar ? 1 : 0) + index)}
        >
          <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
        </svg>
      ))}
    </div>
  );
};

export default StarRating;